module.exports = __webpack_public_path__ + "static/media/stats-mobile4.a6ffe683.png";